/**
 * Télécharger des lignes en CSV lisible par Excel (séparateur « ; », BOM UTF-8) : `columns` = [{ text, value }], où
 * `value` est une clé de la ligne ou une fonction de la ligne.
 */
export function downloadCsv(filename, columns, rows) {
  const cell = value => {
    const text = value === null || value === undefined ? '' : String(value)
    return /[";\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text
  }
  const lines = [
    columns.map(column => cell(column.text)).join(';'),
    ...rows.map(row => columns.map(column => cell(typeof column.value === 'function' ? column.value(row) : row[column.value])).join(';')),
  ]
  const blob = new Blob(['﻿' + lines.join('\r\n')], {type: 'text/csv;charset=utf-8'})
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()
  URL.revokeObjectURL(link.href)
}
